import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useSelector } from "react-redux";
import { AccessibilityHidden } from '@skillz/accessibility';
import { selectEntitiesByFilters } from "../../../store/views/entityView";
import { currentCoursesFilter } from "../../../utils/entitiesFiltersUtils";
import loadingImage from '../../../../assests/loadImage.png';
import classes from './CoursePicture.module.css'

const CoursePicture = ({ picture, courseId }) => {

    const [myPicture, setMyPicture] = useState()
    const { domains, general } = useSelector(state => state.uiData);
    const courses = useSelector(state => selectEntitiesByFilters(state, currentCoursesFilter));

    const isHTML = (value) => !(value || '').replace(/<([^>]+?)([^>]*?)>(.*?)<\/\1>/ig, '').replace(/(<([^>]+)>)/ig, '').trim();

    useEffect(() => {
        if (picture)
            setMyPicture(picture)

        else {
            if (general) {
                if (courseId) {
                    const myCourse = courses?.find(course => course.externalId === courseId)
                    let domainPictures;
                    if (myCourse) {
                        domainPictures = domains?.find(domain => domain.name === myCourse.domain)?.defaultImages
                    }
                    const defaultPictures = domainPictures || general?.defaultDomainsCoursePictures;

                    let total = 0;
                    ([...`${courseId}`]).forEach(p => {
                        if (/^[a-zA-Z]+$/.test(p))
                            total += p.toLowerCase().charCodeAt() - 96
                        else if (/^[1-9]$/.test(p))
                            total += Number(p)
                    })
                    setMyPicture(defaultPictures[Math.abs(total) % defaultPictures.length])
                }
            }
        }
    }, [courses, domains, courseId, picture, general])

    return (
        <AccessibilityHidden>
            {isHTML(myPicture) ?
                <div className={classes.PictureWrapper} dangerouslySetInnerHTML={{ __html: myPicture }}></div>
                :
                <LazyLoadImage
                    className={classes.ProviderImg}
                    alt=""
                    src={myPicture}
                    placeholderSrc={loadingImage}
                    width={"100%"}
                    height={"100%"}
                />
            }
        </AccessibilityHidden >

    )

}

export default CoursePicture